import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { getMerchantInfo, isSiDaMember, isSiDaTeam } from '@util'

export default function(action) {
  return (
    {
      edit_info: {
        path: () => {
          const info = getMerchantInfo()
          const { shop_type, property_id } = info
          if (isSiDaMember()) {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/sidaPersonal?property_id=${property_id}&shop_type=${shop_type}`
          } else if (isSiDaTeam()) {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/sidaGroup?property_id=${property_id}&shop_type=${shop_type}`
          } else {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/editStore?property_id=${property_id}`
          }
        },
        text: '修改入驻信息'
      },
      marketing_ultimate: {
        path: SHOP_PRODUCTS_PATH_A, // 旗舰版营销页
        text: '立即开通'
      },
      marketing_enjoy: {
        path: SHOP_PRODUCTS_PATH_A, // 尊享版营销页
        text: '立即开通'
      },
      perfect_info: {
        path: () => {
          const info = getMerchantInfo()
          const { shop_type, property_id } = info
          if (isSiDaMember()) {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/sidaPersonal?property_id=${property_id}&shop_type=${shop_type}`
          } else if (isSiDaTeam()) {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/sidaGroup?property_id=${property_id}&shop_type=${shop_type}`
          } else {
            return `/p/frontend/merchant-center/dist/index.html#/freeShop/editStore?property_id=${property_id}`
          }
        },
        text: '立即修改' // 完善信息页
      },
      certify: {
        path: () => {
          const info = getMerchantInfo()
          const { shop_type, property_id } = info
          return `/p/frontend/merchant-center/dist/index.html#/freeShop/realnameAuthentication?property_id=${property_id}&shop_type=${shop_type}`
        },
        text: '立即修改'
      }
    }[action] || {}
  )
}
